export default [
    {
        to: "/user", layout: "/rcs", children: [
            {to: "/user/home", text: "总览", component: "home"},
            {to: "/user/message/:type", component: 'message/list'},
            {to: "/user/message/:type/detail/:batchId", component: 'message/detail'},
            {to: "/user/message/:type/create", component: 'message/create'},
            {to: "/user/balance/recharge", text: "充值管理", component : "finance/recharge"},
            {to: "/user/balance/consume", text: "消耗管理", component : "finance/consume"},
            {to: "/user/developer/info", component: "developer/info"},
            {to: "/user/developer/ip", component: "developer/ip"},
            {to: "/user/developer/notify", component: "developer/notify"},
        ]
    },
    {to: "/control/login", component: "login", text: "客户登陆"},
    {to: "/control/register", component: "register", text: "客户注册"}
]
